<template>
  <div>
    <section>
      <div><span class="text-h6">Code Generator</span></div>
      <div id="selectGeneratorDiv">
        <v-select
          ref="selectGenerator"
          v-model="value"
          class="rounded-0"
          variant="outlined"
          density="compact"
          :items="generators"
          item-title="name"
          item-value="type"
          placeholder="Select Generator"
          :menu-props="{ offset: 5 }"
          return-object
        />
      </div>
    </section>
    <section>
      <div><span class="text-h6">Target Folder</span></div>
      <div>
        <span v-if="folderPickerSupported" class="text-body-2"
          >You can select a custom target location on your local file system. Existing files will be overwritten.</span
        >
        <span v-else
          >The generated code will be downloaded as a zip file.</span
        >
      </div>
      <div v-if="folderPickerSupported" class="d-flex align-center pt-6" style="gap: 30px">
        <v-btn @click="selectTargetFolder()">Select Folder</v-btn>
        <v-text-field :model-value="directoryName" :disabled="true" hide-details density="compact"></v-text-field>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { inject, ref, computed, onUpdated } from "vue";
import { GeneratorDownloadService } from "../../services/generation/generator-download-service";
import type { GeneratorMetaData, GenModel } from "./types/generator";

const compProps = defineProps<{
  generators: GeneratorMetaData[];
  genModel: GenModel;
  targetDirectoryHandle: FileSystemDirectoryHandle;
}>();

const emit = defineEmits(["update:genModel", "targetFolderChanged"]);

const generatorDownloadService: GeneratorDownloadService = inject<GeneratorDownloadService>("generatorDownloadService");

const folderPickerSupported = generatorDownloadService.isFolderPickerSupported();

const directoryName = ref(compProps.targetDirectoryHandle?.name || "Downloads");

const selectGenerator = ref(null);

onUpdated(() => {
  selectGenerator.value.$el.querySelector("input").focus();
});

const value = computed({
  get(): GeneratorMetaData {
    return compProps.generators.find((el) => el.type === compProps.genModel.generator.type);
  },

  set(value: GeneratorMetaData) {
    emit("update:genModel", value);
  },
});

async function selectTargetFolder() {
  try {
    /* @ts-expect-error  tbd*/
    const newTargetDirectory = await window.showDirectoryPicker();
    emit("targetFolderChanged", newTargetDirectory);
    directoryName.value = newTargetDirectory?.name || "Downloads";
  } catch (err) {
    return;
  }
}
</script>

<style>
#selectGeneratorDiv .v-field--focused {
  border-width: 0px;
  color: rgba(var(--v-theme-primary));
}
</style>
